module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/sort-title/sort-title.component.scss
// module id = ./src/app/modules/common-module/components/sort-title/sort-title.component.scss
// module chunks = 9